import ActionDialog from '@/components/ui/ActionDialog';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { useBlockingInterface } from '@/features/Onboarding';
import { useState } from 'react';

const betaButtonLabel = 'О бета-версии';
const betaDialogTitle = 'Бета-версия';

const BetaVersionEntry = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useBlockingInterface('beta-version', isOpen);

  const onClickBetaButton = (): void => {
    setIsOpen(true);
  };

  return (
    <>
      <Button
        className={cn(
          'h-10 shrink-0 px-0.5 group',
          'hover:bg-transparent',
          'focus-visible:ring-0 focus-visible:ring-offset-0'
        )}
        aria-label={betaButtonLabel}
        onClick={onClickBetaButton}
        size="md"
        type="button"
        variant="ghost"
      >
        <span
          className={cn(
            'inline-flex h-[21px] w-[41px] items-center justify-center',
            'font-sans text-xs font-semibold leading-4',
            'rounded-[4px] border border-foreground/35 bg-foreground/[0.05] text-muted-foreground',
            'group-hover:bg-foreground/10 group-hover:text-foreground',
            'group-active:bg-foreground/[0.16] group-active:text-foreground',
            'group-focus-visible:ring-2 group-focus-visible:ring-ring',
            'group-focus-visible:ring-offset-2 group-focus-visible:ring-offset-background',
            'dark:border-foreground/40 dark:bg-accent/[0.08]',
            'dark:group-hover:bg-accent/[0.16] dark:group-active:bg-accent/[0.24]',
            'transition-[background-color,color,box-shadow]'
          )}
          aria-hidden="true"
        >
          Beta
        </span>
      </Button>
      <ActionDialog
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        title={betaDialogTitle}
      >
        <div className="flex flex-col gap-3 font-sans text-sm leading-5 text-muted-foreground">
          <p>
            Вы используете раннюю версию приложения. Некоторые функции могут работать нестабильно или быть
            недоступны. Мы активно работаем над улучшениями.
          </p>
          <p>
            Если вы столкнулись с проблемой, то напишите в поддержку по значку в правом верхнем углу.
          </p>
        </div>
      </ActionDialog>
    </>
  );
};

export default BetaVersionEntry;